(() => {
 function init(root=document) {
  root.querySelectorAll('[data-product-section]').forEach(section => {
   if (section.dataset.initialized) return;
   section.dataset.initialized='true';
   const variant=section.querySelector('[data-variant-select]');
   const price=section.querySelector('[data-variant-price]');
   const button=section.querySelector('[data-add-button]');
   if(variant) variant.addEventListener('change',()=>{
    const selected=variant.options[variant.selectedIndex];
    price.textContent=selected.dataset.price;
    button.disabled=selected.dataset.available!=='true';
    button.textContent=button.disabled?'Indisponible':'Ajouter au panier ↗';
    const url=new URL(window.location.href);url.searchParams.set('variant',selected.value);window.history.replaceState({},'',url);
   });

  });
 }
 document.addEventListener('DOMContentLoaded',()=>init());
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();

// Home-page gift questionnaire and navigation, including theme-editor reloads.
(() => {
 function initialize(scope=document) {
  scope.querySelectorAll('[data-gift-builder]').forEach(builder=>{
   if(builder.dataset.ready)return;builder.dataset.ready='true';
   const form=builder.querySelector('[data-gift-form]');
   const choice=form.querySelector('[data-gift-choice]');
   const submit=form.querySelector('[data-gift-submit]');
   const notice=form.querySelector('[data-gift-notice]');
   const result=builder.querySelector('[data-gift-result]');
   const summary=builder.querySelector('[data-gift-summary]');
   function update(){const option=choice.options[choice.selectedIndex];const canBuy=!!option&&option.dataset.purchasable==='true'&&!!option.value;submit.disabled=!option;choice.required=canBuy;submit.textContent=canBuy?'Ajouter au panier ↗':'Préparer mon récapitulatif';notice.textContent=canBuy?'Vos réponses seront jointes au cadeau dans votre panier. Une adresse de livraison par commande.':'Vous pouvez préparer votre cadeau. Cette attention n’est pas encore disponible à la commande.';}
   choice.addEventListener('change',update);update();
   form.addEventListener('submit',event=>{
    const option=choice.options[choice.selectedIndex];
    if(option&&option.dataset.purchasable==='true'&&option.value)return;
    event.preventDefault();
    if(!form.reportValidity())return;
    const lines=['MON IDÉE DE CADEAU',option?option.textContent.trim():''];
    new FormData(form).forEach((value,key)=>{if(key.startsWith('properties[')&&value)lines.push(key.slice(11,-1)+' : '+value);});
    summary.textContent=lines.join('\n\n');form.hidden=true;result.hidden=false;result.focus();
   });
   builder.querySelector('[data-gift-edit]').addEventListener('click',()=>{form.hidden=false;result.hidden=true;choice.focus();});
   builder.querySelector('[data-gift-copy]').addEventListener('click',async()=>{const status=builder.querySelector('[data-copy-status]');try{await navigator.clipboard.writeText(summary.textContent);status.textContent='Récapitulatif copié.';}catch{status.textContent='Sélectionnez le récapitulatif ci-dessus pour le copier.';}});
  });
 }
 function reveal(){if(location.hash==='#preparer-cadeau'){const builder=document.querySelector('[data-gift-builder]');if(builder){builder.open=true;builder.scrollIntoView({block:'start'});}}}
 document.addEventListener('click',event=>{
  const link=event.target.closest('[data-gift-open]');if(!link)return;
  const builder=document.querySelector('[data-gift-builder]');if(!builder)return;
  event.preventDefault();builder.open=true;
  const form=builder.querySelector('[data-gift-form]');form.hidden=false;builder.querySelector('[data-gift-result]').hidden=true;
  const choice=builder.querySelector('[data-gift-choice]');
  if(link.dataset.giftKey){const index=Array.from(choice.options).findIndex(option=>option.dataset.key===link.dataset.giftKey);if(index>=0)choice.selectedIndex=index;choice.dispatchEvent(new Event('change',{bubbles:true}));}
  if(link.dataset.giftMode!==undefined){const mode=link.dataset.giftMode==='1'?'personal':'free';const radio=builder.querySelector('[data-experience-mode="'+mode+'"]');if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}}
  history.replaceState(null,'','#preparer-cadeau');builder.scrollIntoView({block:'start'});choice.focus({preventScroll:true});
 });
 document.addEventListener('DOMContentLoaded',()=>{initialize();reveal();});
 document.addEventListener('shopify:section:load',event=>{initialize(event.target);reveal();});
 window.addEventListener('hashchange',reveal);
})();

(() => {
 function setup(scope=document){
 scope.querySelectorAll('[data-experience]').forEach(experience=>{
  if(experience.dataset.ready)return;experience.dataset.ready='true';
  const form=experience.closest('form');const actions=form.querySelector('[data-checkout-actions]');
  const radios=[...experience.querySelectorAll('[data-experience-mode]')];
  const steps=[...experience.querySelectorAll('[data-experience-step]')];
  const nav=experience.querySelector('[data-experience-navigation]');
  const back=experience.querySelector('[data-experience-back]');const next=experience.querySelector('[data-experience-next]');
  const finish=experience.querySelector('[data-experience-finish]');const progress=experience.querySelector('[data-experience-progress]');
  const details=experience.querySelector('[data-finishing-details]');
  let current=0,mode=null;
  form.noValidate=true;
  function focusStep(){steps[current].focus({preventScroll:true});steps[current].scrollIntoView({block:'nearest'});}
  function update(){
   experience.dataset.mode=mode||'none';
   experience.querySelectorAll('[data-personal-only]').forEach(group=>{group.hidden=mode!=='personal';group.querySelectorAll('input,textarea,select').forEach(input=>{input.disabled=mode!=='personal';if(input.hasAttribute('data-personal-required'))input.required=mode==='personal';});});
   steps.forEach((step,index)=>step.hidden=!mode||(mode==='personal'?index!==current:index===1));
   const last=mode==='free'||(mode==='personal'&&current===2);
   finish.hidden=!last;if(actions)actions.hidden=!last;
   nav.hidden=mode!=='personal';back.hidden=current===0;next.hidden=current===2;progress.hidden=mode!=='personal';
   experience.querySelector('[data-free-reassurance]').hidden=mode!=='free';
   experience.querySelector('[data-finishing-title]').textContent=mode==='personal'?'La touche finale, avec vos mots':'Ajouter un mot ou une précision (facultatif)';
   experience.querySelector('[data-experience-status]').textContent=mode==='free'?'Esprit Libre : quelques repères, puis nous nous occupons du reste.':mode==='personal'?'Sur mesure : étape '+(current+1)+' sur 3. Vos réponses nous aident à composer une attention personnelle.':'Choisissez votre expérience pour commencer.';
   progress.querySelectorAll('li').forEach((li,index)=>{if(index===current)li.setAttribute('aria-current','step');else li.removeAttribute('aria-current');});
  }
  function validate(container){for(const field of container.querySelectorAll('input,textarea,select')){if(!field.disabled&&!field.checkValidity()){field.reportValidity();return false;}}return true;}
  radios.forEach(radio=>radio.addEventListener('change',()=>{if(!radio.checked)return;mode=radio.dataset.experienceMode;current=0;details.open=mode==='personal';update();}));
  next.addEventListener('click',()=>{if(validate(steps[current])){current=Math.min(2,current+1);update();focusStep();}});
  back.addEventListener('click',()=>{current=Math.max(0,current-1);update();focusStep();});
  form.addEventListener('submit',event=>{
   function block(){event.preventDefault();event.stopImmediatePropagation();}
   if(!mode){block();radios[0].reportValidity();return;}
   if(mode==='personal'&&current<2){block();if(validate(steps[current])){current++;update();focusStep();}return;}
   for(let i=0;i<steps.length;i++){
    if(mode==='free'&&i===1)continue;
    const invalid=[...steps[i].querySelectorAll('input,textarea,select')].find(input=>!input.disabled&&!input.checkValidity());
    if(invalid){block();if(mode==='personal'){current=i;update();}if(i===2)details.open=true;invalid.reportValidity();return;}
   }
   if(!validate(finish)){block();return;}
   const outside=[...form.querySelectorAll('input,select,textarea')].find(input=>!experience.contains(input)&&!input.disabled&&!input.checkValidity());
   if(outside){block();outside.reportValidity();}
  },true);
  update();
 });}
 document.addEventListener('DOMContentLoaded',()=>setup());
 document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
